export const COMBINED_RESULTS_LOADED = 'events/COMBINED_RESULTS_LOADED';
export const COMBINED_ENTRY_PAGE_LOADED = 'events/COMBINED_ENTRY_PAGE_LOADED';
export const DETAILS_PANEL_LOADED = 'events/DETAILS_PANEL_LOADED';
export const FLIGHT_DATE_SELECTION_SCREEN_SHOWN = 'events/FLIGHT_DATE_SELECTION_SCREEN_SHOWN';
export const COMBINED_RESULTS_FLIGHTS_ITINERARIES_RENDERED =
  'events/COMBINED_RESULTS_FLIGHTS_ITINERARIES_RENDERED';
export const COMBINED_RESULTS_FLIGHTS_RENDERED = 'events/COMBINED_RESULTS_FLIGHTS_RENDERED';
export const HOMEPAGE_LOADED = 'events/HOMEPAGE_LOADED';
export const HOMEPAGE_FALLBACK_AD_LOADED = 'events/HOMEPAGE_FALLBACK_AD_LOADED';
export const ITINERARIES_BATCH = {
  FIRST: 'FIRST',
  LAST: 'LAST',
} as const;

export const FLIGHTS_DAYVIEW_RENDERED = 'FLIGHTS_DAYVIEW_RENDERED';
export const FLIGHTS_DAYVIEW_ITINERARIES_RENDERED = 'FLIGHTS_DAYVIEW_ITINERARIES_RENDERED';
export const CONFIG_SCREEN_LANDING = 'CONFIG_SCREEN_LANDING';
export const BOOKING_PANEL_LOADED = 'BOOKING_PANEL_LOADED';
export const FLIGHTS_DAY_VIEW_RESULT_SELECTED = 'FLIGHTS_DAY_VIEW_RESULT_SELECTED';
